export default import.meta.ROLLUP_FILE_URL_TWlA7RETIAoTaoA2DnfR4w